/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { View, StyleSheet } from 'react-native';

import { FormField, Text } from '../uiold';
import { themeColors } from '../uiold/Constants';

export default function FormSection(props: {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  noBorderBottom?: boolean;
  zIndex?: number;
}) {
  let { title, subtitle, children, noBorderBottom, zIndex } = props;
  return (
    <FormField
      render={() => (
        <View
          style={[
            styles.formSection,
            noBorderBottom && { borderBottomWidth: 0 },
            zIndex && ({ zIndex } as any),
          ]}
        >
          <View style={styles.flexRow}>
            <View style={styles.flexOne}>
              <Text style={styles.paneHeader}>{title}</Text>
              {subtitle && (
                <Text type="label" style={styles.paneText}>
                  {subtitle}
                </Text>
              )}
            </View>
            <View style={styles.rightPane}>{children}</View>
          </View>
        </View>
      )}
    />
  );
}

let styles = StyleSheet.create({
  formSection: {
    paddingHorizontal: 30,
    borderBottomWidth: StyleSheet.hairlineWidth * 2,
    borderColor: themeColors.lightGrey,
  },
  flexRow: {
    paddingTop: 10,
    paddingBottom: 20,
    flexDirection: 'row',
  },
  flexOne: {
    flex: 1,
  },
  rightPane: {
    flex: 1,
    paddingHorizontal: 20,
  },
  paneHeader: {
    marginBottom: 8,
    fontWeight: '600',
    color: themeColors.darkGrey,
  },
  paneText: {
    color: themeColors.darkGrey,
  },
});
